import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Sparkles, ArrowRight, MessageCircle, Home as HomeIcon } from "lucide-react";

/**
 * Shown to non-admin visitors when `wiki_restricted` is enabled in site settings.
 * Keeps the sci-fi aesthetic and pushes visitors toward Discord / the game.
 */
export default function WikiComingSoon() {
  const { t } = useTranslation();

  return (
    <div
      className="max-w-4xl mx-auto px-4 md:px-6 py-16 md:py-28 text-center relative overflow-hidden"
      data-testid="wiki-coming-soon"
    >
      {/* Ambient glow */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[500px] h-[500px] md:w-[800px] md:h-[800px] rounded-full bg-[radial-gradient(circle,_rgba(58,160,255,0.18)_0%,_transparent_60%)]" />
      </div>

      <div className="relative">
        <div className="inline-flex items-center gap-2 px-3 py-1 border border-[var(--t-border-glow)] mb-6">
          <Sparkles className="w-3 h-3 text-[var(--t-cyan)] pulse-glow" />
          <span className="font-mono text-[10px] md:text-[11px] tracking-[0.3em] text-[var(--t-cyan)] uppercase">
            // {t("wiki.comingSoonEyebrow")}
          </span>
        </div>

        <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl mb-5 leading-[1.05]">
          <span className="block bg-gradient-to-r from-[var(--t-blue-glow)] via-[var(--t-cyan)] to-[var(--t-blue)] bg-clip-text text-transparent">
            {t("wiki.comingSoonTitle1")}
          </span>
          <span className="block text-[var(--t-text)]">{t("wiki.comingSoonTitle2")}</span>
        </h1>

        <p className="text-base md:text-lg text-[var(--t-text-dim)] max-w-2xl mx-auto leading-relaxed mb-9">
          {t("wiki.comingSoonBlurb")}
        </p>

        <div className="flex flex-wrap items-center justify-center gap-3 mb-10">
          <Link to="/" className="btn-ghost" data-testid="wiki-soon-home">
            <HomeIcon className="w-4 h-4" /> {t("nav.home")}
          </Link>
          <Link to="/roadmap" className="btn-primary" data-testid="wiki-soon-roadmap">
            {t("wiki.comingSoonRoadmap")} <ArrowRight className="w-4 h-4" />
          </Link>
          <Link to="/discord" className="btn-ghost !border-[#5865F2] !text-[#9ca6ff] hover:!bg-[rgba(88,101,242,0.12)] hover:!text-[#c5cbff] hover:!border-[#7c87ff]" data-testid="wiki-soon-discord">
            <MessageCircle className="w-4 h-4" /> {t("home.ctaDiscord")}
          </Link>
        </div>

        <div className="font-mono text-[10px] md:text-[11px] tracking-[0.3em] uppercase text-[var(--t-text-muted)]">
          territoria.wiki · <span className="text-[var(--t-blue-glow)]">01 / 01 / 2027</span>
        </div>
      </div>
    </div>
  );
}
